import { useState } from 'react';
import { TeamModel, UserModel } from '../../dto/reporting-models';
import { App, Button, Card, Col, Row } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { TeamForm } from './team-form';

interface TeamCardProps {
  team: TeamModel;
  users: UserModel[];
  usersWithoutTeam?: UserModel[];
  shouldDisplayAddButton: (status: boolean) => void;
  onSubmit: (team: TeamModel, members: UserModel[]) => void;
  deleteTeam: (teamId: number) => void;
}

export const TeamCard = ({ team, users, usersWithoutTeam, shouldDisplayAddButton, onSubmit, deleteTeam }: TeamCardProps) => {
  const { modal } = App.useApp();
  const [shouldEdit, setShouldEdit] = useState(false);

  const cancelEdit = () => {
    setShouldEdit(false);
    shouldDisplayAddButton(true);
  };

  const showDeleteConfirm = () => {
    modal.confirm({
      title: 'Are you sure you want to delete this team?',
      icon: <DeleteOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteTeam(team.id);
      },
    });
  };

  return (
    <Card style={{ margin: '3px 0' }}>
      {shouldEdit ? (
        <TeamForm
          team={team}
          users={users}
          teamMembers={users.filter((u) => u.teamId === team.id)}
          usersWithoutTeam={usersWithoutTeam}
          onSubmit={(team: TeamModel, members: UserModel[]) => {
            onSubmit(team, members);
            setShouldEdit(false);
          }}
          cancel={cancelEdit}
        />
      ) : (
        <Row>
          <Col span={16}>
            <b>{team.name}</b>
            <p>{users.find((m) => m.id === team.leadId)?.fullName || 'No Lead Assigned'}</p>

            <Button
              onClick={() => {
                setShouldEdit(true);
                shouldDisplayAddButton(false);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: '10px' }}
            >
              Edit
            </Button>
            <Button danger onClick={showDeleteConfirm} icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Col>
          <Col span={8}>{team.icon && <img src={decodeURIComponent(team.icon)} alt="team icon" style={{ float: 'right', width: '100px', height: '100px' }} />}</Col>
        </Row>
      )}
    </Card>
  );
};
